import { request } from "./request";
export default function login(payload) {
  const url = process.env.NODE_ENV === 'production' ? '/api/blog/login/' : '/blog/login/';  
  return request({
    url:url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'X-LC-Id': 'r57JSq9yQU4WHkBh3WlJktM0-gzGzoHsz',
      'X-LC-Key': '6B1HmkLavgUf3SKXAGziVUhK'
    },
    data: JSON.stringify(payload)
  })
}
